import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDateInUserTimezone(
  dt: string | Date,
  showTime: boolean,
): string {
  // if dt is a string, convert to date, otherwise keep it as date
  const dateTime = typeof dt === "string" ? new Date(dt) : dt;
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  if (showTime) {
    options.hour = "numeric";
    options.minute = "numeric";
    options.second = "numeric";
    options.timeZoneName = "short";
  }
  const formattedDate = dateTime.toLocaleString("en-US", options);
  return formattedDate;
}

// "Resent once, on <time>" / "Resent 3 times, last on <time>". Shared by the
// transaction detail sentence and the list badge's tooltip so the two cannot
// drift. resendCount and lastResentAt are written in the same statement, so a
// count without a timestamp is not expected; degrade to the bare count rather
// than a dangling "last".
export function resentSummary(
  count: number,
  lastResentAt?: string | Date,
  incoming = false,
): string {
  const verb = incoming ? "Redelivered" : "Resent";
  const stem = count === 1 ? `${verb} once` : `${verb} ${count} times`;
  if (!lastResentAt) return stem;

  const when = formatDateInUserTimezone(lastResentAt, true);
  return count === 1 ? `${stem}, on ${when}` : `${stem}, last on ${when}`;
}

export function appendSearch(
  path: string,
  searchParams: URLSearchParams,
): string {
  const qs = searchParams.toString();
  return qs ? `${path}?${qs}` : path;
}

export function getErrorMessage(
  error: unknown,
  genericMessage: string,
): string {
  if (error && typeof error === "object" && "error" in error) {
    const message = (error as { error: unknown }).error;
    if (typeof message === "string") {
      return message;
    }
  }
  return genericMessage;
}
